import axiosInstance from "../interceptors/axiosInterceptor";

export async function makeRequest(url, options) {
  try {
    const res = await axiosInstance(url, options);
    return res.data;
  } catch (err) {
    return Promise.reject(err);
  }
}
